import { useEffect } from 'react'

import { Container, Grid, Theme } from '@mui/material'
import { useTranslation, Trans } from 'react-i18next'
import { useSession } from 'next-auth/react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useRouter } from 'next/router'

import Button from '@/components/atoms/Button'
import ModalHeader from '@/components/molecules/ModalHeader'
import { LOCALES_WITH_KEYS } from '@/config/constants'
import { configureToken } from '@/services/index'

import ComponentStyled from './styled'

type Props = {
  onConfirm: () => void
  onCancel: () => void
}

const SocialLogged = ({ onConfirm, onCancel }: Props): JSX.Element => {
  const { t } = useTranslation()
  const { data: session, status } = useSession()
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
  const { locale } = useRouter()
  const currentLang = LOCALES_WITH_KEYS.find((v: { id: string }) => v.id === locale)
  const currentPrivacyUrl = currentLang?.privacyUrl || ''

  const userImage = session?.user?.image || ''

  useEffect(() => {
    if (status === 'authenticated') {
      configureToken(session.jwt)
    }
  }, [status, session])

  return (
    <ComponentStyled userImage={userImage}>
      <Container maxWidth='xl'>
        <div className='social-logged-box'>
          <ModalHeader prepend={t('Plant your wish')} />
          <div className='social-logged-content'>
            <p className='logged-title'>
              {t('You are loggin to Schär Plant as')} {session?.user?.name}
            </p>

            {userImage && <div className='avatar' />}
            <p className='info-desc'>
              {t('Schär plant App will receive the following info: your public profile and email address')}
            </p>
            <p className='edit-logged'>
              <span onClick={onCancel}>{t('Edit the info you provide')}</span>
            </p>

            <p className='other-info'>
              <Trans i18nKey='This does not let the app post to <1>socialNetwork</1>'>
                This does not let the app post to <span>{{ socialNetwork: session?.provider || '' }}</span>
              </Trans>
            </p>

            <Grid
              container
              spacing={4}
              justifyContent={isMobile ? 'center' : 'space-between'}
              alignItems={isMobile ? 'inherit' : 'center'}
              className='btns-wrapper'
            >
              <Grid item>
                <a href={currentPrivacyUrl} target='_blank' rel='noreferrer' className='privacy'>
                  {t('Privacy policy')}
                </a>
              </Grid>
              <Grid item xs={12} md='auto'>
                <Grid container spacing={2} justifyContent='flex-end'>
                  <Grid item xs={5} md='auto'>
                    <Button fitToContainer size='small' variant='outline-grey' label={t('Cancel')} onClick={onCancel} />
                  </Grid>
                  <Grid item xs={7} md='auto'>
                    <Button fitToContainer size='small' variant='blue' label={t('Okay')} onClick={onConfirm} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </Container>
    </ComponentStyled>
  )
}

export default SocialLogged
